import type { Week } from "./types";

export const DELIVERY_REQUEST_REGISTER_INPUT_FILE_NAME =
  "RegistrationDeliveryRequest";

export const WEEKS: Array<Week> = ["日", "月", "火", "水", "木", "金", "土"];
